import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { fetchAllTypeaheadRamSlots } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class RamSlotTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadRamSlots: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadRamSlots(RamSlotTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        let options = [];
        if (this.props.suggestions.length) {
            options = this.props.suggestions.map(ram => ({
                label: ram.name, value: ram.id
            }));
        }

        return (
            <MultiTypeahead
                options={options || []}
                disabled={this.props.disabled}
                required={false}
                isClearable={this.props.isClearable}
                isLoading={this.state.isLoading}
                value={this.props.value}
                titleId={this.props.name}
                animatedPlaceholder={this.props.animatedPlaceholder}
                onChangeSuggestion={this.props.onChangeSuggestion}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === RamSlotTypeahead.name
            ? typeahead.list
            : RamSlotTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadRamSlots,
})(RamSlotTypeahead);
